import { httpBus } from "@/api/index.js";

/**
 * 保存/创建文件
 * @param {*} fileName 文件名
 * @param {*} fileJSON 文件内容
 * @param {*} fileLogo 缩略图
 * @param {*} releaseTime 时间
 * @param {*} remark
 * @param {*} id
 * @param {*} stationId
 * @returns
 */
export function save({ fileName, fileJSON, fileLogo, releaseTime, remark, id, stationId, fileType }) {
  let formData = new FormData()
  formData.append('fileName', fileName)
  formData.append('fileJson', JSON.stringify(fileJSON))
  formData.append('fileLogo', fileLogo)
  formData.append('releaseTime', releaseTime)
  formData.append('remark', remark)
  formData.append('id', id)
  formData.append('stationId', stationId)
  formData.append('fileType', fileType)
  return httpBus.request("post", `/device/topology`, { data: formData });
}


/**
 * 获取电站拓扑详细信息
 * @returns 
 */
export function getTopoById(id) {
  return httpBus.request("get", `/device/topology/${id}`);
}

/**
 * 删除电站拓扑信息,id可以传多个 用英文逗号隔开
 * @returns 
 */
export function removeTopoById(ids) {
  return httpBus.request("delete", `/device/topology/${ids}`);
}


/**
 * 获取电站拓扑列表
 * @returns 
 */
export function getTopoList(pageNum = 1, pageSize = 10) {
  return httpBus.request("get", `/device/topology/list`, {
    params: {
      pageNum: pageNum,
      pageSize: pageSize
    }
  });
}

/**
 * 修改电站拓扑发布状态
 * @returns 
 */
export function updateState({ fileName, fileJSON, fileLogo, releaseTime, remark, id, fileType, stationId }) {
  let formData = new FormData()
  formData.append('fileName', fileName)
  formData.append('fileJson', JSON.stringify(fileJSON))
  formData.append('fileLogo', fileLogo)
  formData.append('releaseTime', releaseTime)
  formData.append('remark', remark)
  formData.append('id', id)
  formData.append('fileType', fileType)
  formData.append('stationId', stationId)
  return httpBus.request("get", `/device/topology/updateState`, {
    data: formData
  });
}



/**
 * 根据电站ID获取elink和eblock结构数据
 * @returns 
 */
export function getElinkList(stationId) {
  return httpBus.request("get", `/assetsmng/elink/eLinkList/${Number(stationId)}`);
}



/**
 * 根据电站ID获取elink和eblock结构数据
 * @returns 
 */
export function getTopoDetail(stationId, fileType) {
  return httpBus.request("post", `/device/topology/byType`, {
    data: {
      stationId: stationId,
      fileType: fileType
    }
  });
}


/**
 * 获取自定义原件列表
 * @returns 
 */
export function getCustomElements() {
  return httpBus.request("get", `/device/element/list`);
}

/**
 * 新增拓扑元件
 * @returns 
 */
export function addCustomElement(elementName, enName, elementType, elementPicture) {
  return httpBus.request("post", `/device/element`, {
    data: {
      elementName,
      enName,
      elementType,
      elementPicture
    }
  });
}

/**
 * 删除拓扑元件
 * @returns 
 */
export function deleteCustomElement(elementId) {
  return httpBus.request("delete", `/device/element/${elementId}`);
}


/**
 * 上传拓扑背景图片
 * @returns 
 */
export function uploadImage(bg_picture) {
  let formData = new FormData()
  formData.append('bg_picture', bg_picture, bg_picture.name)
  return httpBus.request("post", `/device/topology/upload`, { data: formData });
}


/**
 * 创建以及修改电站拓扑
 * @returns 
 */
export function postTopology(data) {
  return httpBus.request("post", `/device/v2/station/topology`, { data: data });
}

/**
 * 查询电站拓扑
 * @returns 
 */
export function getTopology(stationId) {
  return httpBus.request("get", `/device/v2/station/topology/${stationId}`);
}
